import {Logger} from '@vanti/vue-logger';

const log = Logger.get('reload');

export default store => {
  let reloadHandle = 0;

  // watch for changes to the version or reload time config value
  store.watch(
      (state, getters) => [getters['config/reloadTime'], getters['versions/upToDate']],
      ([reloadTime, upToDate]) => {
        clearTimeout(reloadHandle);

        // if we're out of date, and we have a reloadTime set, schedule a refresh
        if (!upToDate && reloadTime) {
          // work out the time we should reload
          const now = new Date();
          const dateStr = now.toISOString().split('T')[0] + 'T' + reloadTime;
          const updateTime = new Date(dateStr);
          if (now > updateTime) {
            // try tomorrow
            updateTime.setDate(updateTime.getDate() + 1);
          }

          log.info('Scheduling reload at ' + updateTime);
          reloadHandle = setTimeout(() => {
            store.dispatch('serviceWorker/reload')
                .then(() => window.location.reload())
                .catch(err => log.warn('error while reloading', err));
          }, updateTime.getTime() - now.getTime());
        }
      },
      {
        immediate: true
      }
  );
};
